
export const getAccessToken = () => {
    const auth = localStorage.getItem("AUTHDATA")
    if (auth) {
        return JSON.parse(auth).authToken;
    } else {
        return (process.env && process.env.DEFAULT_TOKEN) ?? undefined;
    }
}

export const downloadBlobFile = (response: any, defaultFilename: string = 'download', format?: string) => {
    const blob = new Blob([response.data], { 
        type: response.headers['content-type'] 
    });
    
    const contentDisposition = response.headers['content-disposition'];
    let filename = defaultFilename;
    
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
    } else if (format) {
        const extensionMap: Record<string, string> = {
            'excel': 'xlsx',
            'xlsx': 'xlsx',
            'pdf': 'pdf'
        };
        const extension = extensionMap[format.toLowerCase()] || format;
        const timestamp = new Date().toISOString().split('T')[0];
        filename = `${defaultFilename}_${timestamp}.${extension}`;
    }
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};



// Razorpay checkout functions
declare global {
    interface Window {
        Razorpay: any;
    }
}

export const openRazorpayCheckout = (subscriptionId: string) => {

    const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_SSzRfZ8k2E9FOi',
        subscription_id: subscriptionId,
        name: 'DriveMynt Subscription',
        description: 'Subscribe to our plan',
        handler: function (response: any) {
            window.location.href = `/subscription/success?subscriptionId=${subscriptionId}`;
        },
        prefill: {
            name: '',
            email: '',
            contact: ''
        },
        theme: {
            color: '#4f46e5'
        }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
};

export const openRazorpayOrderCheckout = (orderId: string, amount: number) => {
    const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_SSzRfZ8k2E9FOi',
        order_id: orderId,
        amount: amount * 100,
        currency: 'INR',
        name: 'DriveMynt Subscription',
        description: 'Upgrade your subscription',
        handler: function (response: any) {
            window.location.href = `/subscription/success?orderId=${orderId}&paymentId=${response.razorpay_payment_id}`;
        },
        prefill: {
            name: '',
            email: '',
            contact: ''
        },
        theme: {
            color: '#4f46e5'
        }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
};
